import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from "@ngneat/until-destroy";
import { EXPENSE_LIST_FULL_PATH, RECEIPT_LIST_FULL_PATH } from 'src/app/shared/shared.module';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { FilledButtonComponent, NTSTranslatePipe } from '@nts/std';
import { OnlineService } from '@nts/std/utility';

@UntilDestroy()
@Component({
  selector: 'nts-receipt-complete-page',
  templateUrl: './receipt-complete-page.component.html',
  styleUrls: ['./receipt-complete-page.component.scss'],
  standalone: true,
  imports: [
    SvgIconComponent,
    FilledButtonComponent,
    NTSTranslatePipe
  ]
})
export class ReceiptCompletePageComponent implements OnInit {

  isUpdate = false;
  isDraft = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private onlineService: OnlineService,
  ) { }

  ngOnInit(): void {
    this.isUpdate = this.activatedRoute.routeConfig.path.startsWith('update-complete');
    this.isDraft = this.activatedRoute.routeConfig.path.startsWith('draft-complete');
  }

  goToDashboard() {
    if (!this?.onlineService?.isOnline) {
      this.router.navigate([`${RECEIPT_LIST_FULL_PATH}`]);
    } else {
      this.router.navigate([`${EXPENSE_LIST_FULL_PATH}`]);
    }
  }
}
